import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AppStatusService } from '../services/app-status.service';

export const maintenanceGuard: CanActivateFn = (_route, _state) => {
  const appStatus = inject(AppStatusService);
  const router = inject(Router);

  if (appStatus.maintenanceMode) {
    router.navigate(['/maintenance']);
    return false;
  }

  return true;
};
